import { render, staticRenderFns } from "./DropShip.vue?vue&type=template&id=442274db&scoped=true&"
import script from "./DropShip.vue?vue&type=script&lang=js&"
export * from "./DropShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442274db",
  null
  
)

export default component.exports